/* cr-pdp.js - Pure Zeo product page (product.v3 templates): the parts of the GemPages engine (assets/gpwc-bundle.js,
   540 KB) this page used, and nothing else. Loaded only when layout/theme.liquid sets crp_native (2026-09-24).
   1. Photo gallery (gp-product-images-v3): the big photo slider (one photo per view, loops, 6px gap) and the thumbnail
      strip (8px gap; loops on tablet/desktop, not on phones). Same motion as before: 500 ms ease-out slides and the
      swipe rules of Swiper, the library GemPages ran: a 5px dead zone, a quick flick (under 300 ms) moves one step, a
      slower drag has to pass half a step, rubber band past the ends of a strip that does not loop.
      Tapping a thumbnail shows that photo and pauses the gallery video. The photo on show gets the bordered thumbnail
      (class gem-slider-item-active) and the strip scrolls to that thumbnail when it is out of view.
      Markup, ids and classes are untouched; CR snippets key on them (.gp-ft-image-item, .gp-gallery-image-item,
      .swiper-thumbs, #crGalVideo, gp-product-images-v3).
   2. The hidden GemPages product form gets quantity 1, as the engine did on load.
   Two deliberate differences: after a thumbnail tap the tapped thumbnail keeps its border (GemPages dropped it), and
   the next swipe continues from the tapped photo (GemPages continued from the photo shown before the tap). */
(function () {
  'use strict';
  var D = document, W = window;
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }
  function kids(el, cls) { return [].filter.call(el.children, function (c) { return c.classList.contains(cls); }); }
  function mod(a, n) { return ((a % n) + n) % n; }
  function dev() { var w = W.innerWidth; return w < 768 ? 'mobile' : (w < 1025 ? 'tablet' : 'desktop'); }

  /* ---------------------------------------------------------------- a slider row
     box = the clipping frame, wrap = the row that moves, items = its slides. pos = how far the row is scrolled, in px
     (the row's transform is -pos). In a looping row, a slide needed on the other side is moved by one full cycle with
     its own transform; at rest no slide is moved unless it has to be, like the old slider. */
  function Track(box, wrap, items, o) {
    var t = { n: items.length, pos: 0, idx: 0, w: 0, loop: false, ready: false, onChange: null };
    var sizes = [], grid = [], snaps = [0], T = 0, max = 0, settleTimer = 0, drag = null;

    function measure() {
      var w = box.clientWidth;
      t.loop = o.loop(dev());
      if (!w) { t.ready = false; return false; }
      t.w = w;
      if (o.pinRow) wrap.style.setProperty('width', w + 'px', 'important');
      items.forEach(function (s) {
        if (o.fill) { s.style.width = w + 'px'; s.style.height = w + 'px'; }
        s.style.marginRight = o.gap + 'px';
      });
      var x = 0; sizes = []; grid = [];
      items.forEach(function (s) { var sz = s.getBoundingClientRect().width; sizes.push(sz); grid.push(x); x += sz + o.gap; });
      T = x; max = Math.max(0, x - o.gap - w);
      snaps = grid.filter(function (g) { return g <= max; });
      if (max - snaps[snaps.length - 1] > 1) snaps.push(max);
      t.ready = true;
      return true;
    }
    function step() { return sizes[0] + o.gap; }
    // looping row: shift each slide by whole cycles so that the stretch lo..hi (row px) is painted.
    // Returns false when some slide would be needed in two places at once (the stretch is too long).
    function place(lo, hi, dry) {
      var ok = true, ks = items.map(function (s, i) {
        if (!t.loop) return 0;
        var a = grid[i], b = a + sizes[i], hits = [];
        [0, -1, 1].forEach(function (k) { if (b + k * T > lo && a + k * T < hi) hits.push(k); });
        if (hits.length > 1) ok = false;
        return hits.length ? hits[0] : 0;
      });
      if (dry || !ok) return ok;
      items.forEach(function (s, i) {
        var tr = ks[i] ? 'translate3d(' + (ks[i] * T) + 'px, 0px, 0px)' : '';
        if (s.style.transform !== tr) s.style.transform = tr;
      });
      return true;
    }
    function paint(p, dur) {
      wrap.style.transitionDuration = dur + 'ms';
      wrap.style.transform = 'translate3d(' + (-p) + 'px, 0px, 0px)';
    }
    function livePos() {   // where the row is right now, mid-animation included
      var m = (W.getComputedStyle(wrap).transform || '').match(/^matrix(3d)?\((.+)\)$/);
      if (!m) return t.pos;
      var v = m[2].split(',');
      return -parseFloat(m[1] ? v[12] : v[4]);
    }
    function settle() {
      clearTimeout(settleTimer); settleTimer = 0;
      var p = t.pos;
      if (t.loop) { p = mod(p, T); if (T - p < 0.5) p = 0; }
      t.pos = p; place(p, p + t.w); paint(p, 0);
    }
    // glide to p (row px). shortWay: a looping row may travel round the loop instead (arrives at the same picture)
    function moveTo(p, dur, shortWay) {
      var cur = livePos();
      clearTimeout(settleTimer); settleTimer = 0;
      if (t.loop) cur = shortWay ? cur + Math.round((p - cur) / T) * T : mod(cur, T);
      if (!dur || Math.abs(p - cur) < 0.5 || !place(Math.min(cur, p), Math.max(cur, p) + t.w, true)) { t.pos = p; settle(); return; }
      place(cur, cur + t.w); paint(cur, 0);
      void wrap.offsetWidth;                 // the transition starts from here
      place(Math.min(cur, p), Math.max(cur, p) + t.w);
      t.pos = p; paint(p, dur);
      settleTimer = setTimeout(settle, dur + 60);
    }
    wrap.addEventListener('transitionend', function (e) { if (e.target === wrap && settleTimer) settle(); });

    function normIndex(p) {   // Swiper: the slide whose stop is nearest below p counts as active
      var idx = 0;
      for (var i = 0; i < grid.length; i++) {
        if (i + 1 < grid.length) {
          if (p >= grid[i] && p < grid[i + 1] - (grid[i + 1] - grid[i]) / 2) idx = i;
          else if (p >= grid[i] && p < grid[i + 1]) idx = i + 1;
        } else if (p >= grid[i]) idx = i;
      }
      return idx;
    }
    // show slide i. Photo slider: slide i's own stop (index may run past either end: it wraps). Strip: Swiper's
    // slideTo, which stops at the end of the strip.
    t.slideTo = function (i, dur, shortWay) {
      if (!t.ready) return;
      var p, real;
      if (o.fill) { real = mod(i, t.n); p = (t.loop ? i : Math.max(0, Math.min(i, t.n - 1))) * step(); if (!t.loop) real = Math.round(p / step()); }
      else { p = snaps[Math.max(0, Math.min(t.loop ? mod(i, t.n) : i, snaps.length - 1))]; real = normIndex(p); }
      var changed = real !== t.idx;
      t.idx = real;
      moveTo(p, dur === undefined ? o.speed : dur, shortWay);
      if (changed && t.onChange) t.onChange(real);
    };
    t.isVisible = function (i) {   // Swiper's test: any part of the slide inside the frame
      var br = box.getBoundingClientRect(), r = items[i].getBoundingClientRect();
      var a = r.left - br.left, b = a + r.width;
      return (a >= 0 && a < t.w - 1) || (b > 1 && b <= t.w) || (a <= 0 && b >= t.w);
    };
    t.relayout = function () {
      if (t.ready && box.clientWidth === t.w && o.loop(dev()) === t.loop) return;
      clearTimeout(settleTimer); settleTimer = 0;
      items.forEach(function (s) { s.style.transform = ''; });
      if (!measure()) return;
      t.pos = o.fill ? t.idx * step() : snaps[Math.min(t.idx, snaps.length - 1)];
      settle();
    };

    /* ---- swipe / drag, Swiper's rules */
    function atStop(p) {
      if (t.loop) { var r = mod(p, step()); return r < 0.5 || step() - r < 0.5; }
      return snaps.some(function (s) { return Math.abs(s - p) < 0.5; });
    }
    function release(cur, next, quick) {
      var stop = 0, a, size;
      if (t.loop) { size = step(); stop = Math.floor(cur / size); a = stop * size; }
      else {
        var toLast = cur >= max; size = sizes[0];
        for (var i = 0; i < grid.length; i++) {
          if (i + 1 < grid.length) { if (toLast || (cur >= grid[i] && cur < grid[i + 1])) { stop = i; size = grid[i + 1] - grid[i]; } }
          else if (toLast || cur >= grid[i]) { stop = i; size = grid[grid.length - 1] - grid[grid.length - 2]; }
        }
        a = grid[stop];
      }
      var ratio = (cur - a) / size, target;
      if (quick) target = next ? stop + 1 : stop;
      else if (next) target = ratio >= 0.5 ? stop + 1 : stop;
      else target = ratio > 0.5 ? stop + 1 : stop;
      if (t.loop) {
        var real = mod(target, t.n), changed = real !== t.idx;
        t.idx = real;
        moveTo(target * size, o.speed, true);
        if (changed && t.onChange) t.onChange(real);
      } else t.slideTo(target);
    }
    function start(x, y, isMouse) {
      if (!t.ready) return;
      drag = { x0: x, y0: y, t0: Date.now(), mouse: isMouse, dir: undefined, moved: false, open: false, from: 0, next: false };
    }
    function move(x, y, e) {
      var g = drag; if (!g) return;
      var dx = x - g.x0, dy = y - g.y0;
      if (g.dir === undefined) {
        if (y === g.y0 && x !== g.x0) g.dir = 'x';
        else if (dx * dx + dy * dy >= 25) g.dir = Math.atan2(Math.abs(dy), Math.abs(dx)) * 180 / Math.PI > 45 ? 'y' : 'x';
        else return;                         // undecided: the page keeps this move (vertical scroll stays possible)
      }
      if (g.dir === 'y') { drag = null; return; }
      if (e.cancelable) e.preventDefault();
      if (!g.moved) {                        // first move: stop a running slide right where it is
        g.moved = true; g.from = livePos(); clearTimeout(settleTimer); settleTimer = 0;
        t.pos = g.from; place(g.from, g.from + t.w); paint(g.from, 0);
      }
      if (!g.open) {                         // 5px dead zone; the drag is counted from where it ends
        if (Math.abs(dx) <= 5) return;
        g.open = true; g.x0 = x; g.y0 = y; return;
      }
      var p = g.from - dx;
      g.next = dx < 0;
      if (!t.loop) {                         // rubber band past the ends
        if (dx > 0 && p < 0) p = 1 - Math.pow(-p, 0.85);
        else if (dx < 0 && p > max) p = max - 1 + Math.pow(p - max, 0.85);
      }
      t.pos = p; place(p, p + t.w); paint(p, 0);
    }
    function end() {
      var g = drag; drag = null;
      if (!g || !g.moved) return;
      if (g.open) swallowClick();
      if (!g.open || Math.abs(t.pos - g.from) < 0.01) { if (!atStop(t.pos)) release(t.pos, false, false); return; }
      release(t.pos, g.next, Date.now() - g.t0 < 300);
    }
    function swallowClick() {   // a drag must not also count as a tap on the thumbnail/photo under it
      var h = function (e) { e.stopPropagation(); e.preventDefault(); box.removeEventListener('click', h, true); };
      box.addEventListener('click', h, true); setTimeout(function () { box.removeEventListener('click', h, true); }, 400);
    }
    box.addEventListener('touchstart', function (e) { if (e.touches.length === 1) { var p = e.touches[0]; start(p.clientX, p.clientY, false); } else drag = null; }, { passive: true });
    box.addEventListener('touchmove', function (e) { if (drag && !drag.mouse) { var p = e.touches[0]; move(p.clientX, p.clientY, e); } }, { passive: false });
    box.addEventListener('touchend', function () { if (drag && !drag.mouse) end(); });
    box.addEventListener('touchcancel', function () { if (drag && !drag.mouse) end(); });
    box.addEventListener('mousedown', function (e) {
      if (e.button !== 0 || (e.target.closest && e.target.closest('video'))) return;   // mouse on the video: its controls win, as before
      start(e.clientX, e.clientY, true);
      if (!(e.target.closest && e.target.closest('input, select, option, textarea, button, label'))) e.preventDefault();
    });
    W.addEventListener('mousemove', function (e) { if (drag && drag.mouse) move(e.clientX, e.clientY, e); });
    W.addEventListener('mouseup', function () { if (drag && drag.mouse) end(); });

    measure();
    return t;
  }

  /* ---------------------------------------------------------------- the gallery */
  function gallery(g) {
    var mRoot = g.querySelector('gp-carousel-v3.gp-feature-image-carousel');
    var mBox = mRoot && mRoot.querySelector('[id^="gp-carousel-ft-"]');
    var mWrap = mBox && mBox.querySelector('.gem-slider-wrapper');
    if (!mWrap) return;
    var mItems = kids(mWrap, 'gem-slider-item');
    var tBox = g.querySelector('[id^="gp-carousel-gp-gallery-"]');
    var tWrap = tBox && tBox.querySelector('.gem-slider-wrapper');
    var tItems = tWrap ? kids(tWrap, 'gem-slider-item') : [];
    var gw = g.querySelector('.gallery-wrapper');

    // everything the old slider set on start, in one go (cr-pdp.css already showed this look before now)
    var main = Track(mBox, mWrap, mItems, { gap: 6, speed: 500, fill: true, loop: function () { return true; } });
    var strip = tItems.length ? Track(tBox, tWrap, tItems, { gap: 8, speed: 500, pinRow: true, loop: function (d) { return d !== 'mobile'; } }) : null;
    [mWrap, tWrap].forEach(function (w) {
      if (!w) return;
      w.style.transitionTimingFunction = 'ease-out';
      w.style.transform = 'translate3d(0px, 0px, 0px)';
    });
    mBox.classList.add('swiper-initialized', 'swiper-horizontal');
    if (tBox) tBox.classList.add('swiper-initialized', 'swiper-horizontal', 'swiper-thumbs');
    if (gw) { gw.style.display = 'flex'; gw.style.height = 'fit-content'; }
    mRoot.setAttribute('active-index', '0'); mRoot.setAttribute('initial-active-index', '0');
    mItems.forEach(function (s) { s.setAttribute('data-outline', 'deactive'); });

    function mark(i) {   // the bordered thumbnail follows the photo on show
      tItems.forEach(function (s, k) {
        s.classList.toggle('gem-slider-item-active', k === i);
        s.setAttribute('data-outline', k === i ? 'active' : 'deactive');
      });
    }
    mark(0);
    main.onChange = function (i) {
      mRoot.setAttribute('active-index', String(i));
      mark(i);
      if (strip && strip.ready && i < tItems.length && i !== strip.idx && !strip.isVisible(i)) strip.slideTo(i, 500, true);
    };
    tItems.forEach(function (s, k) {
      s.addEventListener('click', function () {
        each(mBox.querySelectorAll('video'), function (v) { if (!v.paused) v.pause(); });
        if (k < mItems.length) main.slideTo(k);
      });
    });
    W.addEventListener('resize', function () { main.relayout(); if (strip) strip.relayout(); });
  }

  /* ---------------------------------------------------------------- the product form's quantity */
  function formQuantity() {
    each(D.querySelectorAll('gp-product form[id^="product-form-"] input[name="quantity"]'), function (q) {
      if (!q.value) { q.setAttribute('value', '1'); q.value = '1'; }
    });
  }

  function init() {
    formQuantity();
    each(D.querySelectorAll('gp-product-images-v3'), gallery);
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', init); else init();
})();
